<template>
  <div
    ref="root"
    :key="post.id"
    class="help-center-post__component"
  >
    <main
      class="help-center-post__main"
      :class="mainClass"
    >
      <HelpCenterPostHeader
        :lazy="lazy"
        :post="post"
        :shown-in-flow="shownInFlow"
      />

      <HelpCenterPostArticle
        :post="post"
      />

      <slot
        v-if="shownInFlow"
        name="separator"
      />
      <HelpCenterPostFooter
        v-else
        :post="post"
        :author-map="authorMap"
      >
      </HelpCenterPostFooter>
    </main>

    <div
      v-if="shownInFlow"
      class="help-center-post__pills"
    >
      <HelpCenterPostPills
        :post="post"
        :category-map="categoryMap"
      />
    </div>

    <HelpCenterError :error="error" />
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue'
import { lazyHighlightDocument } from 'gleam-shared/highlight/lazy'
import debounce from 'gleam-shared/helpers/debounce'

import HelpCenterError from 'help-center/components/HelpCenterError'
import HelpCenterPostPills from 'help-center/components/HelpCenterPostPills'
import HelpCenterPostHeader from 'help-center/components/HelpCenterPostHeader'
import HelpCenterPostFooter from 'help-center/components/HelpCenterPostFooter'
import HelpCenterPostArticle from 'help-center/components/HelpCenterPostArticle'

import useLazyEmbed from 'gleam-shared/composables/useLazyEmbed'

const props = defineProps({
  lazy: Boolean,
  post: {
    type: Object,
    required: true
  },
  authorMap: {
    type: Object,
    required: true
  },
  categoryMap: {
    type: Object,
    required: true
  },
  shownInFlow: Boolean
})

const root = ref(null)
const error = useLazyEmbed(root)
const debouncedManageHighlightJS = debounce(manageHighlightJS)

onMounted(debouncedManageHighlightJS)
onUpdated(debouncedManageHighlightJS)

const mainClass = computed(() => {
  if (props.shownInFlow) {
    return 'help-center-post__main--with-pills'
  } else {
    return null
  }
})

function manageHighlightJS() {
  if (props.post?.needs_hljs) {
    lazyHighlightDocument()
  }
}
</script>

<style lang="scss">
@import 'help-center/mixins';

.help-center-post {
  &__component {
    gap: $helpCenterContentPadding;
    display: flex;
    align-items: flex-start;
  }

  &__main {
    width: 100%;

    @include help-center-breakpoint(lg) {
      &--with-pills {
        width: calc(100% - #{$helpCenterPostPillsWidth} - #{$helpCenterContentPadding});
      }
    }
  }

  &__pills {
    @include help-center-show-when(lg);
    gap: 28px;
    width: $helpCenterPostPillsWidth;
    display: flex;
    flex-direction: column;
  }
}
</style>
